import { Controller } from 'stimulus'

export default class extends Controller {

  initialize() {
    this._messageEl = this.element.querySelector(".loading-message")
    this.messages = this._messageEl
      ? JSON.parse(this._messageEl.dataset.loadingMessages || "[]")
      : []
    this._animating = false
    this._stopped = false
  }

  connect() {
    this._startMessageCycle()
  }

  disconnect() {
    this._stopped = true
    this._animating = false
  }

  _startMessageCycle() {
    if (!this.messages.length || !this._messageEl) return
    this._animating = false
    this._cycleMessage(0)
  }

  _cycleMessage(index) {
    if (this._stopped) return

    const isLast = index >= this.messages.length - 1

    this._showMessage(this.messages[index], () => {
      this._animating = false
      if (!isLast) this._cycleMessage(index + 1)
    }, { hold: !isLast })
  }

  _showMessage(text, onDone, { hold = false } = {}) {
    if (this._animating) return
    this._animating = true

    const target = this._messageEl
    if (!target) return

    target.textContent = text
    void target.offsetWidth
    target.style.opacity = "1"

    if (!hold) return

    setTimeout(() => {
      target.style.opacity = "0"
      setTimeout(onDone, 400)
    }, 4000)
  }
}
